import PendingRequestApprovals from './PendingRequestApprovals';

export default PendingRequestApprovals;
